var map = {
	"./icon-actions.svg": 8857,
	"./icon-approval.svg": 89153,
	"./icon-balance.svg": 74516,
	"./icon-contacts.svg": 37863,
	"./icon-forms.svg": 49549,
	"./icon-home.svg": 16789,
	"./icon-loans.svg": 68761,
	"./icon-post.svg": 12470,
	"./icon-reports.svg": 78489,
	"./icon-switch-user.svg": 57024,
	"./icon-user.svg": 40753
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27030;